import React from 'react';

function UserHeader({ userName, isGodFather }) {
    const godFatherStyle = isGodFather ? 'tchat_GfHeader' : '';
    return (
        <div className={`tchat_userHeader ${godFatherStyle}`}>
            <p>{ userName.toUpperCase() }</p>
        </div>
    );
}

export default UserHeader;